import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { configs, DefaultImage, Media, MediaUpload } from "../../../../external-components"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { CarouselProp, RenderConfig } from "./RenderConfig"

const ImageCard = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [urls, setUrls] = useState<Array<string>>(Array.isArray(value?.urls) ? value.urls : ["", "", ""])
  const [titles, setTitles] = useState<Array<string>>(Array.isArray(value?.titles) ? value.titles : ["", "", ""])
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null)

  const openModal = (index: number) => {
    setSelectedImageIndex(index)
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    if (selectedImageIndex === null) return
    const newUrls = [...urls]
    newUrls[selectedImageIndex] = media.url
    setUrls(newUrls)
    onChange({ urls: newUrls, titles })
    setIsModalOpen(false)
    setSelectedImageIndex(null)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedImageIndex(null)
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        {urls.map((url: string, index: number) => (
          <div key={index} className="mb-4">
            <input
              type="text"
              value={titles[index] || ""}
              onChange={e => {
                const newTitles = [...titles]
                newTitles[index] = e.target.value
                setTitles(newTitles)
                onChange({ urls, titles: newTitles })
              }}
              placeholder={`Title for Image ${index + 1}`}
              className="w-full mb-2 p-2 border rounded"
            />

            <input
              type="text"
              value={url}
              onChange={e => {
                const newUrls = [...urls]
                newUrls[index] = e.target.value
                setUrls(newUrls)
                onChange({ urls: newUrls, titles })
              }}
              placeholder={`Image URL ${index + 1}`}
              readOnly
            />

            <div className="relative cursor-pointer group" onClick={() => openModal(index)}>
              <img
                src={url ? `${configs.API_URL}${url}` : DefaultImage}
                alt={`Logo ${index + 1}`}
                className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
              />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
                <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
              </div>
            </div>
            <Button
              onClick={() => openModal(index)}
              type="default"
              variant="outlined"
              className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
            >
              Select Images
            </Button>
          </div>
        ))}
      </div>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>

        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={(media: { url: string }) => handleSelectMedia(media)} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export const CaoCaoCarousel: ComponentConfig<CarouselProp> = {
  label: "CaoCao | Carousel",
  //@ts-ignore
  fields: {
    urls: {
      label: "Image URLs and Titles",
      type: "custom",
      render: props => <ImageCard {...props} />,
    },

    titleStyles: {
      label: "Title Styles",
      type: "object",
      objectFields: {
        position: {
          label: "Position",
          type: "text",
        },
        fontSize: {
          label: "Font Size",
          type: "text",
        },
        color: {
          label: "Text Color",
          type: "text",
        },
        fontWeight: {
          label: "Font Weight",
          type: "text",
        },
        lineHeight: {
          label: "Line Height",
          type: "text",
        },
        textAlign: {
          label: "Text Alignment",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
        },
        padding: {
          label: "Padding",
          type: "text",
        },
        margin: {
          label: "Margin",
          type: "text",
        },
        backgroundColor: {
          label: "Background Color",
          type: "text",
        },
        top: {
          label: "Top Position",
          type: "text",
        },
        left: {
          label: "Left Position",
          type: "text",
        },
        right: {
          label: "Right Position",
          type: "text",
        },
        zIndex: {
          label: "Z-Index",
          type: "text",
        },
        maxWidth: {
          label: "Max-width",
          type: "text",
        },
      },
    },

    imageStyles: {
      label: "Image Styles",
      type: "object",
      objectFields: {
        width: { label: "Width", type: "text" },
        height: { label: "Height", type: "text" },
        padding: { label: "Padding", type: "text" },
        margin: { label: "Margin", type: "text" },
        objectFit: {
          label: "Object Fit",
          type: "select",
          options: [
            { label: "Cover", value: "cover" },
            { label: "Contain", value: "contain" },
            { label: "Fill", value: "fill" },
            { label: "None", value: "none" },
            { label: "Scale Down", value: "scale-down" },
          ],
        },
      },
    },

    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    ...commonStylesProps,
  },
  defaultProps: {
    urls: {
      urls: ["", "", ""],
      titles: ["", "", ""],
    },
    titleStyles: {
      position: "absolute",
      fontSize: "18px",
      color: "#ffffff",
      fontWeight: "bold",
      lineHeight: "64px",
      padding: "0",
      margin: "0",
      backgroundColor: "transparent",
      top: "20px",
      left: "20px",
      right: "auto",
      zIndex: "10",
      maxWidth: "80%",
      // Responsive styles
      // styles: {
      //   mobile: {
      //     fontSize: "14px", // smaller font on mobile
      //     top: "10px", // adjust positioning for smaller screens
      //     left: "10px", // adjust positioning for smaller screens
      //     maxWidth: "90%", // more space for title on mobile
      //   },
      //   tablet: {
      //     fontSize: "16px", // slightly bigger font on tablet
      //     top: "15px", // adjust positioning for tablet screens
      //     left: "15px", // adjust positioning for tablet screens
      //     maxWidth: "85%", // give title a little more space on tablet
      //   },
      //   desktop: {
      //     fontSize: "18px", // default font size for desktop
      //     top: "20px", // default top position for desktop
      //     left: "20px", // default left position for desktop
      //     maxWidth: "80%", // default max width for title
      //   },
      // },
    },
    imageStyles: {
      width: "100%",
      height: "auto",
      padding: "0",
      margin: "0",
      objectFit: "cover",
      // Responsive styles
      // styles: {
      //   mobile: {
      //     width: "100%",  // full width on mobile
      //     height: "auto", // adjust height for mobile
      //   },
      //   tablet: {
      //     width: "100%",  // full width on tablet
      //     height: "auto", // adjust height for tablet
      //   },
      //   desktop: {
      //     width: "100%",  // full width on desktop
      //     height: "auto", // adjust height for desktop
      //   },
      // },
    },
    className: "",
    type: "fluid",
    styles: {
      mobile: {
        display: "flex",
      },
      tablet: {
        display: "flex",
      },
      desktop: {
        display: "flex",
      },
    },
  },

  ...RenderConfig,
}

export default CaoCaoCarousel
